import queryString from 'query-string'
import {
  getLanguageCol,
  trimLinkText,
  stripHtmlTags
} from '../../helpers/utils'

const TYPE_REDIRECT = {
  tutorial: 'tutorials',
  guide: 'guides',
  faq: 'faqs',
  video: 'videos'
}

const getUrl = (item, language, landingDeviceId, devices) => {
  const isExpressHelp =
    parseInt(landingDeviceId, 10) === parseInt(item.phonefk, 10)
  const contentType = isExpressHelp ? 'expresshelp' : TYPE_REDIRECT[item.type]
  const id = item.id || item.pk
  const url = `/${contentType}/${id}`
  const device = devices.find(device => (
    parseInt(device.id, 10) === parseInt(item.phonefk, 10)
  ))

  const query = queryString.stringify({
    // Skip lang query for english
    lang: language !== 'en' ? language : undefined,
    // Skip device when not aviable and for expresshelp
    device: device && !isExpressHelp ? device.slug : undefined
  })

  if (!query) {
    return url
  }

  return `${url}?${query}`
}

const getHighlights = (item, key) => {
  return item.highlight && item.highlight[key]
}

const getTitle = (item, langId) => {
  const titleKey = getLanguageCol('heading', langId, true)
  const highlights = getHighlights(item, titleKey)

  if (highlights && highlights.length > 0) {
    return highlights[0]
  }

  if (item.fields && item.fields[titleKey] && item.fields[titleKey].length > 0) {
    return item.fields[titleKey][0]
  }

  return 'Title missing'
}

const getDescription = (item, langId) => {
  const descriptionKey = getLanguageCol('description', langId, true)
  const highlights = getHighlights(item, descriptionKey)
  const descriptions = item.fields && item.fields[descriptionKey]

  if (highlights && highlights.length > 0) {
    return highlights.join(' ... ')
  }

  if (descriptions && descriptions.length > 0) {
    return trimLinkText(stripHtmlTags(descriptions[0]), 300)
  }

  return ''
}

export default {
  addTitle: langId => item => {
    return { ...item, title: getTitle(item, langId) }
  },

  addDescription: langId => item => {
    return { ...item, description: getDescription(item, langId) }
  },

  addUrl: (language, landingDeviceId, devices) => item => {
    return { ...item, url: getUrl(item, language, landingDeviceId, devices) }
  }
}



// WEBPACK FOOTER //
// ./src/containers/ESSearch/resultProcessor.js